// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"fffc1430","96":"4e95c6bc","127":"8b100ac3","215":"98999c31","329":"00256f42","441":"0a08b6e6","445":"2f1fbe01","579":"256007aa","700":"f4f89210"}[chunkId] + ".chunk.js";
};